import { SButton, SContactNotificationModal } from './ContactNotificationModal.styled'
import { SDot, SDotsContainer } from 'components/dots/DotsContainer'
import { BlockSpinner } from 'components/spinner/Spinner'
import { ReactElement, useState } from 'react'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'

export const ContactNotificationModal = (props: {
  close: () => void
  notificationContents?: ReactElement[]
}) => {
  const { t, isLoading } = useDynamicTranslations('dashboard')
  const [selection, setSelection] = useState(0)
  const skipToNext = () => setSelection((s) => s + 1)
  const isLast = selection === (props.notificationContents?.length || 1) - 1

  if (isLoading) return <BlockSpinner />
  return (
    <SContactNotificationModal>
      {props.notificationContents?.[selection]}
      {(props.notificationContents?.length || 1) > 1 && (
        <SDotsContainer css={{ marginTop: '1rem' }}>
          {props?.notificationContents?.map((_, i) => (
            <SDot key={i} isActive={i === selection} onClick={() => setSelection(i)} />
          ))}
        </SDotsContainer>
      )}
      <SButton type="button" size="large" block onClick={isLast ? props.close : skipToNext}>
        {isLast
          ? t('dashboard.contact_notification_modal.last_button')
          : t('dashboard.contact_notification_modal.next_button')}
      </SButton>
    </SContactNotificationModal>
  )
}
